import type { UpdateAction } from "@app/utils/clientBusiness";
import { getAPIClient } from "../helpers";
import { biAPI } from "./bi";
import { catalogAPI } from "./catalog";
import { devicesAPI } from "./devices";
import { onlineTransactionsAPI } from "./online_transactions";
import { ordersAPI } from "./orders";
import { paymentsAPI } from "./payments";
import { printersAPI } from "./printers";
import { reportsAPI } from "./reports";
import { sessionsAPI } from "./session";
import { shiftsAPI } from "./shifts";
import { tablesAPI } from "./tables";
import { terminalTransactionsAPI } from "./terminal_transactions";
import { promotionsAPI } from "./promotions";
import { reservationsAPI } from "./reservations";
import { customersAPI } from "./customers";
import { reservationRequestsAPI } from "./reservation_requests";
import { restaurantProfileAPI } from "./restaurant_profile";
import { settingsAPI } from "./settings";
import { staffAPI } from "./staff";
import { taxSettingsAPI } from "./tax_settings";
import { paymentIntegrationsAPI } from "./payment_integrations";
import { uploadsAPI } from "./uploads";
import { eventsAPI } from "./events";

export const api = {
  ...catalogAPI,
  ...devicesAPI,
  ...ordersAPI,
  ...sessionsAPI,
  ...tablesAPI,
  ...reportsAPI,
  ...paymentsAPI,
  ...printersAPI,
  ...terminalTransactionsAPI,
  ...shiftsAPI,
  ...biAPI,
  ...onlineTransactionsAPI,
  ...promotionsAPI,
  ...reservationsAPI,
  ...reservationRequestsAPI,
  ...customersAPI,
  ...restaurantProfileAPI,
  ...settingsAPI,
  ...staffAPI,
  ...taxSettingsAPI,
  ...paymentIntegrationsAPI,
  ...uploadsAPI,
  ...eventsAPI,
  fetchAppUpdates: async (params: any) => {
    const hc = getAPIClient();
    const resp = await hc.api.v2.app_updates.$get({
      query: {
        a: 1,
      },
    });
    if (resp.ok) {
      const json = await resp.json();
      return json as unknown as UpdateAction;
    } else {
      return null;
    }
  },
};
